import { Component, OnInit, ViewChild, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { VoyageService } from '../../../core/services/voyage/voyage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import jsPDF from 'jspdf';
import * as es6printJS from 'print-js';
import { UserOptions } from 'jspdf-autotable';
import 'jspdf-autotable';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ReservationmodalComponent } from '../reservationmodal/reservationmodal.component';
import { ReservationService } from '../../../core/services/reservation/reservation.service';


interface jsPDFWithPlugin extends jsPDF {
  autoTable: (options: UserOptions) => jsPDF;
}

@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.css']
})
export class ReservationComponent implements OnInit {
  @Output() selectedreservation = new EventEmitter<any>();

  voyageid: any;

  displayedColumns = [
    "id",
    "ticket",
    "passager",
    "phone",
    "bus",
    "tarif",
    "siege",
    "destination",
    "category",
    "date",
    "action",
  ];
  dataSource = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  lastprintstate: boolean | undefined;
  agence: any;
  base64: any;
  ispopup: any;
  reservationlist: any;

  constructor(
    private dialog: MatDialog,
    private voyageservice: VoyageService,
    private activatedRoute: ActivatedRoute,private http: HttpClient,
    private changeDetectorRef: ChangeDetectorRef, private datepipe: DatePipe,
    private router: Router, private reservationService: ReservationService
  ) {
    this.voyageid = this.activatedRoute.snapshot.params["id"];
    this.sort = new MatSort();
    this.agence = localStorage.getItem('agenceinso');
    this.agence = this.agence != null ? JSON.parse(this.agence) : null;
  }

  ngOnInit(): void {
    this.getreservationlist();

  }

  getreservationdata(data: any): any{
    this.selectedreservation.emit(data);
  }

  getreservationlist(): any {
    this.reservationService
      .getAllReservtion(0, 10)
      .subscribe((response: any) => {
        // console.log(response);
        this.reservationlist = response;
        this.dataSource = new MatTableDataSource(this.reservationlist.content);
        this.changeDetectorRef.detectChanges();
      });
  }

  nextPage(event: PageEvent): any {
    const page = event.pageIndex;
    const size = event.pageSize;
    this.reservationService
      .getAllReservtion(page, size)
      .subscribe((newPageData: any) => {
        this.reservationlist = newPageData;
        this.dataSource = new MatTableDataSource(this.reservationlist?.content);
      });
  }



  delete(data: any) {}

  addReservation(): any {

    this.ispopup = true;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    // dialogConfig.position={
    //   right:'110px',
    // };
    dialogConfig.data = {};
    const dialogref = this.dialog.open(ReservationmodalComponent, {
      width: '650px', height: 'auto', autoFocus: true, disableClose: dialogConfig.disableClose, data: {}
    });

    dialogref.afterClosed().subscribe((result: any) => {
      this.ispopup = false;
      // this.addReservation();
    });
  }

  editreservation(data: any): any {}
}
